#import "./customWorkOrderFieldInfo.gql"

query GetAllCustomWorkOrderFields {
  customWorkOrderFields {
    ...customWorkOrderFieldInfo
  }
}
